/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function CoverDefault({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.2} d="m9 5.125 1.798-1.798M9 5.125l1.798 1.798M9 5.125h5.8m-7.8 0L5.202 3.327M7 5.125 5.202 6.923M7 5.125H1.2" /><path stroke="currentColor" strokeWidth={1.2} d="M3 2.75V2.5A1.5 1.5 0 0 1 4.5 1h7A1.5 1.5 0 0 1 13 2.5v.25m0 4.72v.28a1.5 1.5 0 0 1-1.5 1.5h-7A1.5 1.5 0 0 1 3 7.75v-.28" /><path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.2} d="M4 12.125h8M4 14.5h5" /></svg>;
}
;